var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import cx from 'classnames';
import { Typography } from '../../foundations/typography';
import { BadgeType } from './types';
import styles from './Badge.module.scss';
/**
 * @tdr
 */
export var Badge = forwardRef(function (_a, ref) {
    var _b;
    var className = _a.className, fitParent = _a.fitParent, Icon = _a.icon, _c = _a.type, type = _c === void 0 ? BadgeType.DEFAULT : _c, text = _a.text, _d = _a.textStyle, textStyle = _d === void 0 ? 'paragraphSmall' : _d, rest = __rest(_a, ["className", "fitParent", "icon", "type", "text", "textStyle"]);
    var classNames = cx(styles.badge, styles[type], className, (_b = {},
        _b[styles.fitParent] = fitParent,
        _b));
    return (React.createElement("span", __assign({ className: classNames, ref: ref }, rest),
        !!Icon && React.createElement(Icon, { size: "xsmall", className: styles.icon }),
        React.createElement(Typography, { element: "span", noMargins: true, styleAs: textStyle }, text)));
});
//# sourceMappingURL=Badge.js.map